import React, { forwardRef, useId } from 'react'

export interface RadioProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string
  error?: boolean
  helperText?: string
}

const Radio = forwardRef<HTMLInputElement, RadioProps>(
  ({ label, error, helperText, className = '', disabled, id, ...props }, ref) => {
    const autoId = useId()
    const radioId = id || `radio-${autoId}`

    return (
      <div className="inline-flex flex-col">
        <div className="flex items-center">
          <input
            ref={ref}
            id={radioId}
            type="radio"
            className={`w-4 h-4 text-blue-600 bg-white border-gray-300 focus:ring-0 focus:ring-offset-0 ${
              error ? 'border-red-500' : ''
            } ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'} ${className}`}
            disabled={disabled}
            {...props}
          />
          {label && (
            <label
              htmlFor={radioId}
              className={`ml-2 text-sm font-medium ${
                error ? 'text-red-700' : 'text-gray-900'
              } ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
            >
              {label}
            </label>
          )}
        </div>
        {helperText && (
          <p className={`mt-1 text-xs ${error ? 'text-red-600' : 'text-gray-500'}`}>
            {helperText}
          </p>
        )}
      </div>
    )
  }
)

Radio.displayName = 'Radio'

export default Radio
